import { Component, h, Listen, State } from '@stencil/core';
import { loadTranslation } from "@helpers/utils";
import { UserData } from "@helpers/user-data";

import coinbaseWalletModule from "@web3-onboard/coinbase";
import walletConnectModule from "@web3-onboard/walletconnect";
import injectedModule from "@web3-onboard/injected-wallets";
import Onboard from "@web3-onboard/core";

import { setUserWallet, clearUserWallet } from '@helpers/user-data-stencil-store';

@Component({
  tag: 'app-root',
  styleUrl: 'app-root.scss',
})
export class AppRoot {

  /* ---------------------- OWN PROPERTIES ---------------------- */
  publicPages = ['/login', '/registration', '/forgot-pwd', '/recovery-pwd'];
  connectWallet;
  wallets;
  onboard;

  itTranslations = {
    "connect": {
      "selectingWallet": {
        "header": "Wallet Disponibili",
        "sidebar": {
          "heading": "",
          "subheading": "Connetti il tuo wallet",
          "paragraph": "Collegare il tuo wallet è come effettuare il “login” nel Web3. Seleziona il tuo wallet tra le opzioni per iniziare.",
          "IDontHaveAWallet": "Non ho un wallet"
        },
        "recommendedWalletsPart1": "{app} supporta solo",
        "recommendedWalletsPart2": "su questa piattaforma. Utilizza o installa uno dei wallet supportati per continuare",
        "installWallet": "Non hai installato alcun wallet supportato da {app}, utilizza un wallet supportato",
        "agreement": {
          "agree": "Accetto i",
          "terms": "Termini e Condizioni",
          "and": "e",
          "privacy": "l'Informativa sulla Privacy"
        },
        "whyDontISeeMyWallet": "Perché non vedo il mio wallet?",
        "learnMore": "Clicca qui per saperne di più"
      },
      "connectingWallet": {
        "header": "{connectionRejected, select, false {Connessione a {wallet}...} other {Connessione Rifiutata}}",
        "sidebar": {
          "subheading": "Approva la Connessione",
          "paragraph": "Approva la connessione nel tuo wallet e autorizza l'accesso per continuare."
        },
        "mainText": "Connessione in corso...",
        "paragraph": "Assicurati di selezionare tutti gli account a cui desideri concedere l'accesso.",
        "previousConnection": "{wallet} ha già una richiesta di connessione in sospeso, apri l'app {wallet} per accedere e connetterti.",
        "rejectedText": "Connessione Rifiutata!",
        "rejectedCTA": "Clicca qui per riprovare",
        "primaryButton": "Torna ai wallet"
      },
      "connectedWallet": {
        "header": "Connessione Avvenuta con Successo",
        "sidebar": {
          "subheading": "Connessione Avvenuta con Successo!",
          "paragraph": "Il tuo wallet è ora connesso a {app}"
        },
        "mainText": "Connesso"
      }
    },
    "modals": {
      "actionRequired": {
        "heading": "Azione richiesta in {wallet}",
        "paragraph": "Modifica l'account attivo nel tuo wallet.",
        "linkText": "Scopri di più.",
        "buttonText": "Ok"
      },
      "switchChain": {
        "heading": "Cambia Rete",
        "paragraph1": "{app} richiede di cambiare la rete del tuo wallet a {nextNetworkName} per continuare.",
        "paragraph2": "*Alcuni wallet potrebbero non supportare il cambio di rete. Se non puoi cambiare rete nel tuo wallet, considera l'uso di un altro wallet."
      },
      "confirmDisconnectAll": {
        "heading": "Disconnetti tutti i Wallet",
        "description": "Sei sicuro di voler disconnettere tutti i tuoi wallet?",
        "confirm": "Conferma",
        "cancel": "Annulla"
      },
      "confirmTransactionProtection": {
        "heading": "Abilita la Protezione delle Transazioni",
        "description": "Proteggi gli endpoint RPC nascondendo la tua transazione dai bot di front-running e sandwich.",
        "link": "Scopri di più",
        "enable": "Abilita",
        "dismiss": "Ignora"
      }
    },
    "accountCenter": {
      "connectAnotherWallet": "Connetti un altro Wallet",
      "disconnectAllWallets": "Disconnetti tutti i Wallet",
      "currentNetwork": "Rete Attuale",
      "enableTransactionProtection": "Abilita la Protezione delle Transazioni",
      "appInfo": "Informazioni sull'App",
      "learnMore": "Scopri di più",
      "gettingStartedGuide": "Guida per Iniziare",
      "smartContracts": "Smart Contract",
      "explore": "Esplora",
      "poweredBy": "offerto da",
      "addAccount": "Aggiungi Account",
      "setPrimaryAccount": "Imposta Account Primario",
      "disconnectWallet": "Disconnetti Wallet",
      "copyAddress": "Copia indirizzo del Wallet"
    },
    "notify": {
      "transaction": {
        "txRequest": "La tua transazione è in attesa di conferma",
        "nsfFail": "Fondi insufficienti per questa transazione",
        "txUnderpriced": "Il prezzo del gas per la tua transazione è troppo basso, prova un prezzo del gas più alto",
        "txRepeat": "Questa potrebbe essere una transazione duplicata",
        "txAwaitingApproval": "Hai una transazione precedente in attesa di conferma",
        "txConfirmReminder": "Conferma la tua transazione per continuare",
        "txSendFail": "Hai rifiutato la transazione",
        "txSent": "La tua transazione è stata inviata alla rete",
        "txStallPending": "La tua transazione è bloccata prima di essere inviata, riprova",
        "txStuck": "La tua transazione è bloccata a causa di un gap di nonce",
        "txPool": "La tua transazione è iniziata",
        "txStallConfirmed": "La tua transazione è bloccata e non è stata confermata",
        "txSpeedUp": "La tua transazione è stata accelerata",
        "txCancel": "La tua transazione è in fase di annullamento",
        "txFailed": "La tua transazione è fallita",
        "txConfirmed": "La tua transazione è riuscita",
        "txError": "Ops, qualcosa è andato storto, riprova",
        "txReplaceError": "C'è stato un errore nel sostituire la tua transazione, riprova"
      },
      "watched": {
        "txPool": "Il tuo account sta {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        "txSpeedUp": "La transazione per {formattedValue} {asset} {preposition} {counterpartyShortened} è stata accelerata",
        "txCancel": "La transazione per {formattedValue} {asset} {preposition} {counterpartyShortened} è stata annullata",
        "txConfirmed": "Il tuo account ha completato con successo {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        "txFailed": "Il tuo account non è riuscito a {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        "txStuck": "La tua transazione è bloccata a causa di un gap di nonce"
      },
      "time": {
        "minutes": "min",
        "seconds": "sec"
      }
    }
  };


  /* ---------------------- @STATE ------------------------------ */
  @State() isLogged: boolean = false;
  @State() walletAddress: string = undefined;

  /* -------------------- LIFECYCLE EVENTS ---------------------- */
  async componentWillLoad() {
    // Load the app translation
    loadTranslation();
  }

  async componentDidLoad() {
    console.log('Component has been rendered');
    await this.checkAndRedirect(window.location.pathname);
    this.handleWallets();
  }

  /* -------------------- @LISTEN ------------------------------- */
  @Listen('ionRouteWillChange')
  async listenRouteChange(e) {
    const targetUrl = e.detail.to;
    await this.checkAndRedirect(targetUrl);
  }

  // Evento che viene scatenato se l'utente non è loggato oppure è loggato ma con un token non valido
  @Listen('unauthorizedEvent', { target: 'window' })
  async listenUnauthorizedEvent() {
    await UserData.doLogout();
    this.isLogged = false;
  }

  /* -------------------- LOCAL METHODS ------------------------- */

  @Listen('connectWalletEv')
  async listenConnectWallet() {
    console.log('connectWalletEv');  

    this.walletAddress = await UserData.getUserWalletAddress();
    console.log('-- DENTRO AL LISTEN', await UserData.getUserWalletAddress());

    // Se ho già un wallet connesso allora disconnetto, altrimenti apro la modale per la connessione
    if (this.walletAddress != null || this.walletAddress != undefined || this.walletAddress == 'undefined') {

      this.alertDisconnectWallet();
   
    
    } else {
        console.log('ho un wallet');
        this.connectWalletFunction();
    }
  }

 async disconnectWallet(){
    //Recupera i wallet attualmente connessi
    const connectedWallets = this.onboard.state.get().wallets;

    // Se ci sono wallet connessi, disconnettili
    if (connectedWallets.length > 0) {
      for (const wallet of connectedWallets) {
        await this.onboard.disconnectWallet({ label: wallet.label });
      }
    }
  }

  async alertDisconnectWallet() {
  const alert = document.createElement('ion-alert');
  alert.header = 'Disconnessione Wallet';
  alert.message = 'Vuoi disconnettere il wallet attuale?';
    alert.buttons = [
      {
        text: 'Annulla',
        role: 'cancel',
        handler: () => {
          console.log('Alert canceled');
        },
      },
      {
        text: 'Disconnetti',
        role: 'confirm',
        handler: () => {
          console.log('Alert confirmed');
          this.disconnectWallet();
        },
      },
    ];


  document.body.appendChild(alert);
  await alert.present();
}
  
  handleWallets(){
    const coinbaseWalletSdk = coinbaseWalletModule();
    const injected = injectedModule();
    const walletConnect = walletConnectModule({
      projectId: '4560cba46a109dceb125fc627d2730a9',
      dappUrl: "https://fnmloyalty.sitointest.it/"
    });

    const modules = [coinbaseWalletSdk, walletConnect, injected];

    this.onboard = Onboard({
      wallets: modules, // created in previous step
      connect: {
        autoConnectLastWallet: true,
      },
      chains: [
        {
          id: "0x1", // chain ID must be in hexadecimal
          token: "ETH",
          namespace: "evm",
          label: "Ethereum Mainnet",
          rpcUrl: "https://mainnet.infura.io/v3/8e1f1759776341a28dbfd3d63ccce63f"
        },
        // you can add as much supported chains as possible
      ],
      appMetadata: {
        name: "FNMClub", // change to your dApp name
        icon: "/assets/icons/app_icon.svg", // paste your icon
        logo: "/assets/logos/logo.svg", // paste your logo
        description: "App Fidality di fnm",
        recommendedInjectedWallets: [
          { name: "Coinbase", url: "https://wallet.coinbase.com/" },
          { name: "MetaMask", url: "https://metamask.io" }
        ]
      },
      accountCenter: {
        desktop: {
          enabled: false,
        },
        mobile: {
          enabled: false,
        }
      },
      i18n: {
        it: this.itTranslations
      }
    });

    // Ascolto il cambiamento sulla variabile WALLETS.
    this.onboard.state.select('wallets').subscribe(wallets => {
      if (wallets.length > 1) {
        console.log('STATE.SELECT(WALLETS) | More than one wallet');
        this.onboard.disconnectWallet({ label: wallets[1].label }); // Disconnetto il wallet in posizione 1
        this.setWalletAddress(wallets[0].accounts[0].address); // Imposto la variabile del wallet address dal wallet nuovo
       // loadNftInCollectionSingle("nft-singoli", this.walletAddress);
      } else if (wallets.length == 0) {
        console.log('STATE.SELECT(WALLETS) | no more wallets');
        clearUserWallet(); // Svuoto la variabile dell'indirizzo del wallet
      } else if (wallets.length == 1) {
        console.log('STATE.SELECT(WALLETS) | only one wallet');
        this.setWalletAddress(wallets[0].accounts[0].address); // Imposto la variabile del wallet address dal wallet nuovo


        //loadNftInCollectionSingle("nft-singoli", this.walletAddress);
      }
    });
  }

  async connectWalletFunction() {
    console.log('connectWalletFunction');
      try {
          // Recupera i wallet attualmente connessi
          const connectedWallets = this.onboard.state.get().wallets;
          console.log('CONNECTED WALLETS', connectedWallets);

          // Se ci sono wallet connessi, disconnettili
          if (connectedWallets.length > 0) {
              for (const wallet of connectedWallets) {
                  await this.onboard.disconnectWallet({ label: wallet.label });
               // this.setWalletAddress(undefined);
              }
          }

          // Connetti un nuovo wallet
          this.wallets = await this.onboard.connectWallet();

        console.log('this.wallets', this.wallets);

          // Logica aggiuntiva, come ottenere l'indirizzo dell'utente
          if (this.wallets && this.wallets.length > 0) {
              console.log('HO LOGGATO', this.wallets);
              const userAddress = this.wallets[0].accounts[0].address;
              if (userAddress) {
                  this.setWalletAddress(userAddress);
              }
          }
      } catch (error) {
          console.error('Errore durante la connessione del wallet:', error);
      }
  }


  /**
 * Imposto le preferences con l'indirizzo del wallet
 * @param address indirizzo del wallet
 */
  async setWalletAddress(address) {
    setUserWallet(address);
  }


  async checkIfLogged() {
    const userApiKey = await UserData.getUserApiKey();
    // voglio fare il console.log(userApiKey) per vedere se è valorizzato
    console.log('userApiKey', userApiKey);
    return !!userApiKey;
  }

  async checkAndRedirect(targetUrl: string) {
    const router = await document.querySelector('ion-router').componentOnReady() as HTMLIonRouterElement;
    const isLogged = await this.checkIfLogged();

    if (targetUrl === '/' || targetUrl === '') {
      if (isLogged) {
        console.log('Utente LOGGATO e prova ad andare in pagina ROOT')
        router.push('/user/home', 'forward');
      } else {
        console.log('Utente SLOGGATO e prova ad andare in pagina ROOT');
        router.push('/login', 'forward');
      }
    } else if (!this.publicPages.includes(targetUrl) && !isLogged) {
      console.log('Utente SLOGGATO e prova ad andare in pagina PRIVATA');
      router.push('/login', 'forward');
    } else if (this.publicPages.includes(targetUrl) && isLogged) {
      console.log('Utente LOGGATO e prova ad andare in pagina PUBBLICA');
      router.push('/user/home', 'forward');
    }
  }

  /* --------------------- RENDER ------------------------------- */
  render() {
    return (
      <ion-app>
        {this.renderRouter()}
        <ion-nav />
      </ion-app>
    );
  }

  renderRouter() {
    return (
      <ion-router useHash={false}>
        <ion-route url="/" component="page-spinner"></ion-route>
        <ion-route url="/login" component="page-login"></ion-route>
        <ion-route url="/registration" component="page-registration"></ion-route>
        <ion-route url="/user/welcome" component="page-welcome"></ion-route>
        <ion-route url="/forgot-pwd" component="page-forgot-pwd"></ion-route>
        <ion-route url="/recovery-pwd" component="page-recovery-pwd"></ion-route>
        <ion-route url="/user/profile" component="page-profile"></ion-route>
        
        <ion-route component="page-tabs">
          <ion-route url="/user/home" component="tab-home" >
            <ion-route component="page-home"></ion-route>
          </ion-route>
          <ion-route url="/user/my-rewards/" component="tab-my-rewards">
            <ion-route component="page-my-rewards"></ion-route >
            <ion-route url="/nft/:userid" component="page-my-rewards-nft"></ion-route >
            <ion-route url="/discounts/:userid" component="page-my-rewards-discounts"></ion-route >
            <ion-route url="/tickets/:userid" component="page-my-rewards-tickets"></ion-route >
            <ion-route url="/donations/:userid" component="page-my-rewards-donations"></ion-route >

          </ion-route>
          <ion-route url="/user/rewards" component="tab-rewards" >
            <ion-route component="page-rewards-catalogue"></ion-route >
            <ion-route url="/choose/:tab" component="page-rewards"></ion-route >
            <ion-route url="/collection/:collectionname" component="page-rewards-collection-details"></ion-route>
          </ion-route>
          <ion-route url="/user/earn" component="tab-earn" >
            <ion-route component="page-earn"></ion-route >
          </ion-route>
          <ion-route url="/user/challenges" component="tab-challenges" >
            <ion-route component="page-challenges"></ion-route >
          </ion-route>
        </ion-route>

      </ion-router>
    );
  }
}
